const MAX_PARALLEL_HISTORY_IO_OPS = 20;

export { MAX_PARALLEL_HISTORY_IO_OPS };
